import { combineReducers } from '@reduxjs/toolkit';

import { createToggleReducer } from 'modules/utils';
import {
  acceptRentalDocuments,
  acceptRentalDocumentsFailure,
  acceptRentalDocumentsSuccess,
  acceptRepairOrder,
  acceptRepairOrderFailure,
  acceptRepairOrderSuccess,
  confirmClientDocuments,
  confirmClientDocumentsFailure,
  confirmClientDocumentsSuccess,
  confirmDropOff,
  confirmDropOffFailure,
  confirmDropOffSuccess,
  confirmPickUp,
  confirmPickUpFailure,
  confirmPickUpSuccess,
  openDropOffLocker,
  openDropOffLockerFailure,
  openDropOffLockerSuccess,
  openPickUpLocker,
  openPickUpLockerFailure,
  openPickUpLockerSuccess,
  payBilling,
  payBillingFailure,
  payBillingSuccess,
  reportIssues,
  reportIssuesFailure,
  reportIssuesSuccess,
} from 'modules/entity/subEntities/appointment/actions';

export const acceptRentalDocumentsIsLoading = createToggleReducer(
  acceptRentalDocuments,
  acceptRentalDocumentsSuccess,
  acceptRentalDocumentsFailure
);

export const acceptRepairOrderIsLoading = createToggleReducer(
  acceptRepairOrder,
  acceptRepairOrderSuccess,
  acceptRepairOrderFailure
);

export const confirmClientDocumentsIsLoading = createToggleReducer(
  confirmClientDocuments,
  confirmClientDocumentsSuccess,
  confirmClientDocumentsFailure
);

export const payBillingIsLoading = createToggleReducer(payBilling, payBillingSuccess, payBillingFailure);

export const reportIssuesIsLoading = createToggleReducer(reportIssues, reportIssuesSuccess, reportIssuesFailure);

export const dropOffConfirmIsLoading = createToggleReducer(confirmDropOff, confirmDropOffSuccess, confirmDropOffFailure);

export const dropOffOpenIsLoading = createToggleReducer(
  openDropOffLocker,
  openDropOffLockerSuccess,
  openDropOffLockerFailure
);

export const pickUpConfirmIsLoading = createToggleReducer(confirmPickUp, confirmPickUpSuccess, confirmPickUpFailure);

export const pickUpOpenIsLoading = createToggleReducer(
  openPickUpLocker,
  openPickUpLockerSuccess,
  openPickUpLockerFailure
);

/**
 * @typedef {{
 *  ui: {
 *   general: {
 *    acceptRentalDocuments: { isLoading: boolean },
 *    acceptRepairOrder: { isLoading: boolean },
 *    confirmClientDocuments: { isLoading: boolean },
 *    payBilling: { isLoading: boolean },
 *    reportIssues: { isLoading: boolean },
 *   },
 *   dropOff: {
 *    confirm: { isLoading: boolean },
 *    open: { isLoading: boolean },
 *   },
 *   pickUp: {
 *    confirm: { isLoading: boolean },
 *    open: { isLoading: boolean },
 *   },
 *  },
 * }} AppointmentReducerState
 */

export default combineReducers({
  ui: combineReducers({
    general: combineReducers({
      acceptRentalDocuments: combineReducers({ isLoading: acceptRentalDocumentsIsLoading }),
      acceptRepairOrder: combineReducers({ isLoading: acceptRepairOrderIsLoading }),
      confirmClientDocuments: combineReducers({ isLoading: confirmClientDocumentsIsLoading }),
      payBilling: combineReducers({ isLoading: payBillingIsLoading }),
      reportIssues: combineReducers({ isLoading: reportIssuesIsLoading }),
    }),
    dropOff: combineReducers({
      confirm: combineReducers({ isLoading: dropOffConfirmIsLoading }),
      open: combineReducers({ isLoading: dropOffOpenIsLoading }),
    }),
    pickUp: combineReducers({
      confirm: combineReducers({ isLoading: pickUpConfirmIsLoading }),
      open: combineReducers({ isLoading: pickUpOpenIsLoading }),
    }),
  }),
});
